/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useState } from 'react'
import { Label } from './common/label'
import { useForm } from './form'
import { SelectFilterObj } from './common/select-filter-ob'
import { useLoad } from '../hooks/load'

export const FormSimpleCategoryOrganizationSelectFilter = ({ name, label, rootName, organizationID, useApiListCategory, hidden, required }) => {
  const { register, setValue, getFormDisabled } = useForm(name, { required, valueAsNumber: true, forceChange: true, shouldDirty: true })

  const [selectedItem, updateSelectedItem] = useState(null)

  const apiListCategory = useApiListCategory()

  useLoad(
    () => {
      if (organizationID) {
        apiListCategory.get(`hierarchy/${organizationID}/organization`)
        updateSelectedItem(null)
      } else {
        apiListCategory.init()
      }
    },
    [organizationID]
  )

  useLoad(() => (selectedItem && selectedItem.id ? setValue(selectedItem.id) : setValue(null)), [selectedItem])

  const disabled = getFormDisabled()

  const items = useMemo(
    () => {
      let items = apiListCategory.items.map(item => {
        return { id: item.id, path: `/ ${rootName} ${item.path}` }
      })

      return [{ id: -1, path: `/ ${rootName}` }, ...items]
    },
    [apiListCategory]
  )

  return (
    <Label name={name} label={label} hidden={hidden} required={required}>
      <input type="hidden" {...register()} />
      {/* Keyed by the organization: a new organization starts the field over
          (owner 2026-10-15), so a search typed for the old one never filters
          the new one's categories, and an open list closes. */}
      <SelectFilterObj key={organizationID || 'none'} rootName={rootName} items={items} itemKey="path" selectedItem={selectedItem} disabled={disabled} onChange={updateSelectedItem} />
    </Label>
  )
}
